import { Dataset, GridRow } from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import { REPORT_MASTER_ROW_ID } from '../../../utils/dataset/reportRelations';

export const promoteRowsToReportMaster = (
  dataset: Dataset,
  rows: GridRow[]
): GridRow[] => {
  const dataKey = getDataKey(dataset);

  return rows.map((row, index) => ({
    ...row,
    [REPORT_MASTER_ROW_ID]: String(
      row[dataKey] ?? row[REPORT_MASTER_ROW_ID] ?? `report-master-${index}`
    ),
  }));
};
